<template>
  <div class="information" style="min-height:35vw">
    <div class="container clearf">
      <div class="left-box">
        <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-bottom:15px;">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>问题列表</el-breadcrumb-item>
        </el-breadcrumb>
        <el-tabs v-model="activeName3" @tab-click="handleClick3" >
          <template v-for=" (item,index) in nameList">
            <el-tab-pane :label="item.names" :key="index"  :name="item.idName" :data="item.category">
              <ul class="info-list">
                <li class="list-style2" style="margin-top:0;" v-for="(setitem,index) in content" :key="index">
                  <router-link :to="{path:'/questionDetails',query:{tid:setitem.tid}}">
                    <a class="list-title">{{setitem.title}}</a>

                    <div class="style-box clearf">
                      <div class="left" v-if="setitem.picUrl">
                        <img :src="$img+setitem.picUrl" />
                      </div>
                      <div
                        class="right"
                        :style="{width:setitem.picUrl?'calc(100% - 220px)':'100%'}"
                      >
                        <p style="margin-bottom:20px;">{{setitem.detail}}</p>
                        <div class="list-bottoms" >
                          <span >
                            <i class="iconfont icon-shijian"></i>
                            {{setitem.publishDate | timer}}
                          </span>
                          <span>发布人：{{setitem.publishByName}}</span>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </li>
              </ul>
            </el-tab-pane>
          </template>
        </el-tabs>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next,jumper"
          :total="Datas.totalElements"
        ></el-pagination>
      </div>
      <div class="right-box">
        <recommendation />
        <div class="box-questtions">
          <router-link :to="{path:'/hotline'}">
            <!-- <div class="questtions">去提问</div> -->
            <img src="/static/img/quests.jpg" alt />
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import recommendation from "../components/recommendation";
import "@/assets/iconfont/iconfont.css";
import moment from 'moment'
export default {
  data() {
    return {
      //分页数据
      currentPage: 1,
      pageSize: 20,
      pageNum: 1,
      totalPages: 0,
      page: 1,
      category: "4b6edd40d2ab11e9bddcda211f4fee1e",
      content: [],
      Datas: "",
      nameList: [
        {
          names: "技术类",
          category: "4b6edd40d2ab11e9bddcda211f4fee1e",
          idName: "0"
        },
        {
          names: "政策类",
          category: "5aae1135d2ab11e9bddcda211f4fee1e"
        },
        {
          names: "市场类",
          category: "6868bab8d2ab11e9bddcda211f4fee1e"
        }
      ],
      activeName3: "",
      dictTypeCode: "question_category"
    };
  },
  components: {
    recommendation
  },
  created() {
    this.getbriefList();
  },
  filters: {
    timer(value) {
      return moment(value).format("YYYY-MM-DD");
    }
  },
  methods: {
    //类别查询
    queryDataDict() {
      const data = {
        dictTypeCode: this.dictTypeCode
      };
      this.$api.questionApi
        .queryDataDict(data)
        .then(res => {
          console.log("类别=>", res);
          this.nameList = res.data.respData;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // elm-tab组件点击
    handleClick3(tab, event) {
      console.log(tab.$attrs.data);
      this.category = tab.$attrs.data;
      this.getbriefList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getbriefList();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getbriefList();
    },
    getbriefList: function() {
      let data = {
        category: this.category,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      this.$api.questionApi
        .questionList(data)
        .then(res => {
          console.log("问题列表=>", res);
          this.Datas = res.data.respData;
          this.content = res.data.respData.content;
          this.totalPages = res.data.respData.totalPages;
        })
        .catch(err => {
          console.log("err=>", err);
        });
    }
  }
};
</script>
<style lang="less" >
//element样式修改
.el-breadcrumb {
  background-color: #fff;
  height: 35px;
  line-height: 35px;
  font-size: 16px;
  padding: 0 15px;
}
.el-breadcrumb__inner.is-link {
  color: #333;
  font-weight: normal;
  &:hover {
    color: #333;
  }
}
.el-breadcrumb__item:last-child .el-breadcrumb__inner {
  color: #149508;
  &:hover {
    color: #149508;
  }
}
.el-breadcrumb__separator {
  color: #333;
}
.el-pager li.active {
  color: #149508;
}
.el-pagination {
  padding: 20px 0;
  margin: 0 auto;
  text-align: center;
}
.el-pager li:hover {
  color: #149508;
}

.left-box {
  float: left;
  width: 848px;
  margin-top: 20px;
  .info-list {
    li {
      position: relative;
      width: 100%;
      background-color: #fff;
      margin-bottom: 15px;
      padding: 20px;
      .list-title {
        display: block;
        font-size: 18px;
        color: #333;
        font-weight: 700;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 808px;
        &:hover {
          color: #149508;
        }
      }
      .style-box {
        margin: 10px 0;
        p {
          color: #666;
          line-height: 32px;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
      }
      .left {
        float: left;
        width: 200px;
        height: 133px;
        margin-right: 20px;
      }
      .right {
        float: left;
        width: calc(100% - 220px);
        // width: auto;
      }
      .list-bottoms {
        position: absolute;
        bottom: 30px;
        right: 20px;
        color: #999;
        font-size: 14px;
        span {
          margin-left: 30px;
          i {
            margin-right: 5px;
          }
        }
      }
    }
  }
}
.el-tabs {
  width: 100%;
  margin-bottom: 10px;
}
.el-tabs__nav-wrap::after {
  height: 0;
}
// .tap-conts .el-tabs__header {
//   background: #fff;
//   padding: 0 15px;
// }
.el-tabs__header{
   padding: 0 15px !important;
  background: #fff;
}
.el-tabs__item {
  font-size: 18px;
  padding: 0px 30px;
}
.el-tabs__item.is-active {
  color: #149508;
}
.el-tabs__item:hover {
  color: #149508;
  cursor: pointer;
}
.el-tabs__active-bar {
  background-color: #149508;
}
.text-end {
  text-align: end;
}
.box-questtions {
  width: 100%;
  padding-top: 20px;
  .questtions {
    width: 150px;
    padding: 10px 0px;
    text-align: center;
    border-radius: 18px;
    margin: 0 auto 0;
    background: #149508;
    color: #fff;
  }
  img {
    width: 331px;
    height: 150px;
  }
}

.right-box {
  float: right;
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/questiontList.vue